/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedResultFile
 */
export interface PatchedResultFile {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  filename?: string;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  created?: Date;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedResultFile interface.
 */
export function instanceOfPatchedResultFile(value: object): value is PatchedResultFile {
  return true;
}

export function PatchedResultFileFromJSON(json: any): PatchedResultFile {
  return PatchedResultFileFromJSONTyped(json, false);
}

export function PatchedResultFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedResultFile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    filename: json["filename"] == null ? undefined : json["filename"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedResultFileToJSON(json: any): PatchedResultFile {
  return PatchedResultFileToJSONTyped(json, false);
}

export function PatchedResultFileToJSONTyped(
  value?: Omit<PatchedResultFile, "url" | "simulation" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    description: value["description"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    file: FileReadOnlyToJSON(value["file"]),
  };
}
